import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, ElementRef, ViewContainerRef } from '@angular/core';
import { DomHandler } from 'prime-ng-old/dom';
import { UiIconsModule } from '../icons';
import * as i0 from "@angular/core";
import * as i1 from "../icons/icon.component";
const _c0 = ["text"];
const _c1 = ["uiButton", ""];
const _c2 = ["*"];
function UiButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.loading ? "circle-notch" : ctx_r0.icon)("spin", ctx_r0.loading)("size", ctx_r0.iconSize)("fixedWidth", !!ctx_r0.label || ctx_r0.hasContent());
  }
}
const _c3 = ["content"];
const _c4 = ["uiHoverLabelButton", ""];
function UiHoverLabelButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.loading ? "circle-notch" : ctx_r0.icon)("spin", ctx_r0.loading)("size", ctx_r0.iconSize)("fixedWidth", true);
  }
}
function UiHoverLabelButtonComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", null, 1);
    i0.ɵɵtext(2);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label ? "\u00A0" + ctx_r0.label : "", " ");
  }
}
const _c5 = ".ui-button{--borderLeftRadius:var(--buttonBorderRadius);--borderRightRadius:var(--buttonBorderRadius);--buttonActiveZIndex:2;margin:0;padding:0;color:var(--buttonTextColor);background-color:var(--buttonBgColor);border:1px solid #C20D7A;border-color:var(--buttonBorderColor);border-width:var(--buttonBorderWidth);border-radius:var(--borderLeftRadius);border-top-right-radius:var(--borderRightRadius);border-bottom-right-radius:var(--borderRightRadius);font-size:1em;font-weight:400;display:inline-block;cursor:pointer;position:relative;text-decoration:none!important;text-align:center;overflow:visible;transition:background-color .3s,border-color .3s}.ui-button.small{font-size:.85em}.ui-button.medium{font-size:1.15em;padding:10px!important}.ui-button.large{font-size:1.3em;padding:15px!important}.ui-button.ui-button-outline{border-width:var(--buttonOutlineBorderWidth, 2px)}@media (max-width: 767px){.ui-button.small-md{font-size:.85em}}.ui-button .ui-button-content{display:block;line-height:normal}.ui-button .ui-button-content span{vertical-align:middle}.ui-button .ui-button-icon{color:var(--buttonIconColor);display:inline-block;vertical-align:middle}.ui-button .ui-button-icon .svg-inline--fa{margin:0!important}.ui-button.ui-button-icon-size-sm .ui-button-icon{width:14px;height:14px;line-height:14px}.ui-button.ui-button-icon-size-lg .ui-button-icon{width:22px;height:22px;line-height:22px}.ui-button.ui-button-icon-size-2x .ui-button-icon{width:32px;height:32px;line-height:32px}.ui-button.ui-button-disabled,.ui-button:disabled{opacity:.5;cursor:default}.ui-button:not(:disabled):hover{background-color:var(--buttonHoverBgColor);color:var(--buttonHoverTextColor);border-color:var(--buttonHoverBorderColor);z-index:var(--buttonActiveZIndex)}.ui-button:not(:disabled):hover .ui-button-icon{color:var(--buttonHoverIconColor)}body.a11y-highlight-interactible .ui-button:not(:disabled){outline:var(--a11yInteractibleElementOutline)!important;outline-offset:var(--a11yInteractibleElementOutlineOffset)!important;outline-color:var(--a11yInteractibleElementOutlineColor)!important}.ui-button:not(:disabled):focus{background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}body.a11y-emphasize-focus .ui-button:not(:disabled):focus{transform:scale(1.1)!important}.ui-button:not(:disabled){z-index:var(--buttonActiveZIndex)}.ui-button:not(:disabled):active{background-color:var(--buttonActiveBgColor);color:var(--buttonActiveTextColor);border-color:var(--buttonActiveBorderColor);z-index:var(--buttonActiveZIndex)}.ui-button:not(:disabled):active .ui-button-icon{color:var(--buttonActiveIconColor)}.ui-button.ui-button-text-only .ui-button-content{padding:.4em 1em}.ui-button.ui-button-text-only.small .ui-button-content{padding:.5em .7em}@media (max-width: 767px){.ui-button.ui-button-text-only.small-md .ui-button-content{padding:.5em .7em}}.ui-button.ui-button-text-icon-left .ui-button-content{padding:.4em 1em}.ui-button.ui-button-text-icon-left .ui-button-content>span{margin-left:.5em}.ui-button.ui-button-text-icon-left.small .ui-button-content{padding:.5em .7em}@media (max-width: 767px){.ui-button.ui-button-text-icon-left.small-md .ui-button-content{padding:.5em .7em}}.ui-button.ui-button-text-icon-right .ui-button-content{padding:.4em 1em}.ui-button.ui-button-text-icon-right .ui-button-content>span{margin-right:.5em}.ui-button.ui-button-text-icon-right .ui-button-icon{float:right}.ui-button.ui-button-text-icon-right.small .ui-button-content{padding:.5em 1.4em}@media (max-width: 767px){.ui-button.ui-button-text-icon-right.small-md .ui-button-content{padding:.5em 1.4em}}.ui-button.ui-button-icon-only .ui-button-content{padding:.429em;text-indent:0!important;min-width:22px;text-align:center}.ui-button.ui-button-icon-only .ui-button-icon{display:flex;justify-content:center;min-width:17px}.ui-button.ui-button-icon-only.small .ui-button-content{padding:.5em}@media (max-width: 767px){.ui-button.ui-button-icon-only.small-md .ui-button-content{padding:.5em}}.ui-button.ui-button-text-hover{padding:12px;text-indent:0!important;text-align:center}.ui-button.ui-button-text-hover .ui-button-content{white-space:nowrap;overflow:hidden;padding:0!important;display:flex}.ui-button.ui-button-raised{box-shadow:0 2px 3px #00000059}.ui-button.ui-button-rounded{--borderLeftRadius: var(--roundedButtonBorderRadius);--borderRightRadius:var(--roundedButtonBorderRadius)}body.a11y-no-distraction-mode .ui-button:not(.ui-button-icon-only) .ui-button-icon{display:none}.ui-fluid .ui-button-icon-only{width:2.357em}.ui-togglebutton{background-color:var(--toggleButtonBgColor);border:1px solid #dadada;border-color:var(--toggleButtonBorderColor);color:var(--toggleButtonTextColor);transition:background-color .3s,border-color .3s}.ui-togglebutton .ui-button-icon-left{color:var(--toggleButtonIconColor)}.ui-togglebutton:not(.p-disabled):not(.p-highlight):hover{background-color:var(--toggleButtonHoverBgColor);border-color:var(--toggleButtonHoverBorderColor);color:var(--toggleButtonHoverTextColor)}.ui-togglebutton:not(.p-disabled):not(.p-highlight):hover .ui-button-icon-left{color:var(--toggleButtonHoverIconColor)}.ui-togglebutton:not(.p-disabled):not(.p-highlight){background-color:var(--toggleButtonFocusBgColor);border-color:var(--toggleButtonFocusBorderColor);color:var(--toggleButtonFocusTextColor)}body.a11y-highlight-interactible .ui-togglebutton:not(.p-disabled):not(.p-highlight){outline:var(--a11yInteractibleElementOutline)!important;outline-offset:var(--a11yInteractibleElementOutlineOffset)!important;outline-color:var(--a11yInteractibleElementOutlineColor)!important}.ui-togglebutton:not(.p-disabled):not(.p-highlight):focus{background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}.ui-togglebutton:not(.p-disabled):not(.p-highlight) .ui-button-icon-left{color:var(--toggleButtonFocusIconColor)}.ui-togglebutton.p-highlight{background-color:var(--toggleButtonActiveBgColor);border-color:var(--toggleButtonActiveBorderColor);color:var(--toggleButtonActiveTextColor)}.ui-togglebutton.p-highlight .ui-button-icon-left{color:var(--toggleButtonActiveIconColor)}.ui-togglebutton.p-highlight:hover{background-color:var(--toggleButtonActiveHoverBgColor);border-color:var(--toggleButtonActiveHoverBorderColor);color:var(--toggleButtonActiveHoverTextColor)}.ui-togglebutton.p-highlight:hover .ui-button-icon-left{color:var(--toggleButtonActiveHoverIconColor)}.ui-togglebutton.p-highlight.p-focus{background-color:var(--toggleButtonActiveFocusBgColor);border-color:var(--toggleButtonActiveFocusBorderColor);color:var(--toggleButtonActiveFocusTextColor)}.ui-togglebutton.p-highlight.p-focus .ui-button-icon-left{color:var(--toggleButtonActiveFocusIconColor)}@media (max-width: 640px){.ui-buttonset .ui-button{margin-bottom:1px;border-radius:3px}}.ui-splitbutton.ui-buttonset .ui-button{border:1px solid transparent}.ui-splitbutton.ui-buttonset .ui-menu{min-width:100%}\n";
// custom component using primeng ui-button styles
/**
 * available style classes (implemented in css-variables.scss):
 * ui-button-invisible
 * ui-button-outline
 * ui-button-grey
 * ui-button-secondary
 * ui-button-primary (same as default)
 * ui-button-contrast
 * ui-button-info
 * ui-button-success
 * ui-button-warning
 * ui-button-danger
 * ui-button-disabled
 */
export let UiButtonComponent = /*#__PURE__*/(() => {
  class UiButtonComponent {
    set disabled(v) {
      if (typeof this.el.nativeElement['disabled'] !== 'undefined') {
        this.el.nativeElement['disabled'] = v;
      }
      this._disabled = v;
    }
    get disabled() {
      return this._disabled;
    }
    set styleClass(cls) {
      this.setCustomClass(cls);
    }
    constructor(el, target, cd) {
      this.el = el;
      this.target = target;
      this.cd = cd;
      this.isButton = true;
      /*
          because disabled is defined as Input, it will not set native disabled attribute anymore.
          use a setter to update the native attribute manually.
      */
      this._disabled = false;
      this.iconSize = 'md';
      this.iconPos = 'left';
      this.raised = false;
      this.toggled = false;
      this.rounded = false;
      this.initialized = false;
    }
    ngAfterViewInit() {
      DomHandler.addMultipleClasses(this.el.nativeElement, this.getStyleClass());
      this.initialized = true;
    }
    setCustomClass(cls) {
      if (this._styleClass?.length) {
        this._styleClass.split(' ').forEach(clsToRemove => {
          DomHandler.removeClass(this.el.nativeElement, clsToRemove);
        });
      }
      this._styleClass = cls;
      if (cls.length > 0) DomHandler.addMultipleClasses(this.el.nativeElement, cls);
    }
    // STATIC! Will only be evaluated once!
    // if editing, make sure there always is exactly one space between classes! Will error otherwise!
    getStyleClass() {
      let styleClass = 'ui-button p-component';
      if (this.rounded) styleClass += ' ui-button-rounded';
      if (this.hasContent()) {
        if (!this.icon) {
          styleClass += ' ui-button-text-only';
        } else if (this.iconPos === 'left') {
          styleClass += ' ui-button-text-icon-left';
        } else {
          styleClass += ' ui-button-text-icon-right';
        }
      } else {
        styleClass += ' ui-button-icon-only';
      }
      if (this.raised) {
        styleClass += ' ui-button-raised';
      }
      if (this.icon) {
        styleClass += ' ui-button-icon-size-' + this.iconSize;
      }
      return styleClass;
    }
    hasContent() {
      return this.textContent && !!this.textContent.nativeElement.innerHTML.trim();
    }
    static {
      this.ɵfac = function UiButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiButtonComponent,
        selectors: [["", "uiButton", ""]],
        viewQuery: function UiButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textContent = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function UiButtonComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ui-button", ctx.isButton)("ui-button-disabled", ctx.disabled);
          }
        },
        inputs: {
          disabled: "disabled",
          icon: "icon",
          iconSize: "iconSize",
          iconPos: "iconPos",
          raised: "raised",
          toggled: "toggled",
          rounded: "rounded",
          loading: "loading",
          label: "label",
          styleClass: "styleClass"
        },
        attrs: _c1,
        ngContentSelectors: _c2,
        decls: 7,
        vars: 2,
        consts: [["content", ""], ["text", ""], [1, "ui-button-content"], [1, "ui-button-icon", 3, "icon", "spin", "size", "fixedWidth"]],
        template: function UiButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "span", 2, 0);
            i0.ɵɵconditionalCreate(2, UiButtonComponent_Conditional_2_Template, 1, 4, "ui-icon", 3);
            i0.ɵɵelementStart(3, "span", null, 1);
            i0.ɵɵtext(5);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.icon || ctx.loading ? 2 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.label);
          }
        },
        dependencies: [UiIconsModule, i1.UiIconComponent],
        styles: [_c5],
        encapsulation: 2
      });
    }
  }
  return UiButtonComponent;
})();
export let UiHoverLabelButtonComponent = /*#__PURE__*/(() => {
  class UiHoverLabelButtonComponent extends UiButtonComponent {
    constructor() {
      super(...arguments);
      this.isHoverButton = true;
      this.stayOpen = false;
      this.hovering = false;
      this.iconPos = 'left';
    }
    updateHoverState($event) {
      const tmp = $event.type === 'mouseenter';
      if (tmp !== this.hovering) {
        this.setStartWidth();
        this.hovering = tmp;
        this.cd.markForCheck();
      }
    }
    getGrowAnimation() {
      return {
        value: this.hovering,
        params: {
          startWidth: this.startWidth
        }
      };
    }
    setStartWidth() {
      if (this.startWidth !== this.content.nativeElement.clientWidth) {
        this.startWidth = this.content.nativeElement.clientWidth;
        this.cd.markForCheck();
      }
    }
    ngOnChanges() {
      this.setStartWidth();
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiHoverLabelButtonComponent_BaseFactory;
        return function UiHoverLabelButtonComponent_Factory(__ngFactoryType__) {
          return (ɵUiHoverLabelButtonComponent_BaseFactory || (ɵUiHoverLabelButtonComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiHoverLabelButtonComponent)))(__ngFactoryType__ || UiHoverLabelButtonComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiHoverLabelButtonComponent,
        selectors: [["", "uiHoverLabelButton", ""]],
        viewQuery: function UiHoverLabelButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c3, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function UiHoverLabelButtonComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseleave", function UiHoverLabelButtonComponent_mouseleave_HostBindingHandler($event) {
              return ctx.updateHoverState($event);
            })("mouseenter", function UiHoverLabelButtonComponent_mouseenter_HostBindingHandler($event) {
              return ctx.updateHoverState($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("ui-button-text-hover", ctx.isHoverButton);
          }
        },
        inputs: {
          stayOpen: "stayOpen"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        attrs: _c4,
        ngContentSelectors: _c2,
        decls: 4,
        vars: 3,
        consts: [["content", ""], ["text", ""], [1, "ui-button-content"], [1, "ui-button-icon", 3, "icon", "spin", "size", "fixedWidth"]],
        template: function UiHoverLabelButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "span", 2, 0);
            i0.ɵɵconditionalCreate(2, UiHoverLabelButtonComponent_Conditional_2_Template, 1, 4, "ui-icon", 3);
            i0.ɵɵconditionalCreate(3, UiHoverLabelButtonComponent_Conditional_3_Template, 4, 1, "span");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("@grow", ctx.getGrowAnimation());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.icon || ctx.loading ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hovering || ctx.stayOpen ? 3 : -1);
          }
        },
        dependencies: [UiIconsModule, i1.UiIconComponent],
        styles: [_c5],
        encapsulation: 2,
        data: {
          animation: [trigger('grow', [transition('void <=> *', []), transition('* <=> *', [style({
            width: '{{startWidth}}px',
            opacity: 0
          }), animate('.3s ease')], {
            params: {
              startWidth: 0
            }
          })])]
        }
      });
    }
  }
  return UiHoverLabelButtonComponent;
})();